/* eslint-disable no-magic-numbers */
import { memoize } from "decko";

export default class AuBusinessNumbers {
  @memoize
  static validate(vatId) {
    const cleaned = `${vatId}`.replace(/\D/g, "");

    if (!/^\d{11}$/.test(cleaned)) {
      return false;
    }

    const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

    const digits = [...cleaned].map(Number);

    digits[0] -= 1;

    const sum = digits.reduce((acc, digit, idx) => acc + (digit * weights[idx]), 0);

    return sum % 89 === 0;
  }

  @memoize
  static format(abn) {
    return abn && `${abn}`.replace(/[^0-9]/g, "").replace(/(\d{2})(\d{1,3})?(\d{1,3})?(\d{1,3})?/,
      (match, matchA, matchB, matchC, matchD) => {
        return [matchA, matchB, matchC, matchD].filter(Boolean).join(" ");
      });
  }
}
